import React from 'react';
import { Spin } from 'antd';
import styled from 'styled-components';

const Container = styled.div`
  text-align: center;
`;

const Loader = props => (
  <Container className={props.className}>
    <Spin tip={props.text || 'Loading...'} />
  </Container>
);

export default Loader;



// WEBPACK FOOTER //
// ./src/components/Core/Loader.js